import ENDPOINTS from "../ApiManager/CamaEndPoints";
import environment from "../environments/environment";

const BASE_URL = environment.api_url;

class CamaService {

	static getCamas = (establecimientoId) => {
		const url = BASE_URL + ENDPOINTS.GET_CAMAS(establecimientoId);
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};



	static getCamasByParams = (establecimientoId, idHabitacion, activo, tipoCama, edificio, planta) => {
		const url = BASE_URL + ENDPOINTS.GET_CAMAS_BY_PARAMS(establecimientoId, idHabitacion, activo, tipoCama, edificio, planta);
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};



	static getTiposCama = () => {
		const url = BASE_URL + ENDPOINTS.GET_TIPOS_CAMA();
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}

		});
	};



	static crearCama = (cama) => {
		const url = BASE_URL + ENDPOINTS.POST_CAMA();

		return fetch(url, {
			method: 'POST',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				identificador: cama.identificador,
				tamanyo: cama.tamanyo,
				idMotor: cama.idMotor,
				fechaInstalacion: cama.fechaInstalacion,
				habitacion: cama.habitacion,
				activo: cama.activo,
				mac: cama.mac,
				tipoCama: cama.tipoCama
			})
		});
	};

	static actualizarCama = (cama) => {
		const url = BASE_URL + ENDPOINTS.ACTUALIZAR_CAMA(cama.id);

		return fetch(url, {
			method: 'PUT',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				identificador: cama.identificador,
				tamanyo: cama.tamanyo,
				idMotor: cama.idMotor,
				fechaInstalacion: cama.fechaInstalacion,
				habitacion: cama.habitacion,
				activo: cama.activo,
				mac: cama.mac,
				tipoCama: cama.tipoCama
			})
		});
	};



	static desactivarCama = (camaId) => {
		const url = BASE_URL + ENDPOINTS.DELETE_CAMA() + camaId;

		return fetch(url, {
			method: 'DELETE',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};


}

export default CamaService;
